const value = Object.freeze({
  AssignStudent: 0,
  UnassignStudent: 1,
  CustodianHistory: 2,
  Seize: 3,
  ViewAllBooksAssigned: 4,
  AdditionalInfo: 5,
  TransferInfo: 6,
});
export default value;
